// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__DHhf+","section-1":"styles_section-1__-m7gT","content":"styles_content__BultV","section-2":"styles_section-2__1cZCG"};